module.exports = __webpack_public_path__ + "img/add-skill.af36cd7c.svg";